import { RefObject, useEffect, useState } from 'react';

interface CSS {
    [key: string]: string | undefined;
}

const useSetProperties = (
    css: CSS | undefined,
    elemRef: RefObject<any> | null
) => {
    const [completed, setCompleted] = useState<boolean>(false);
    const cssProperties = css ? css : null;

    useEffect(() => {
        if (!cssProperties) {
            return;
        }

        const element = elemRef?.current;
        if (!element) {
            return;
        }

        Object.getOwnPropertyNames(cssProperties).forEach(
            (cssProperty: any) => {
                const cssValue = cssProperties[cssProperty];
                elemRef?.current.style.setProperty(
                    `--${cssProperty}`,
                    cssValue
                );
            }
        );

        setCompleted(true);
    }, [elemRef, cssProperties]);

    return completed;
};

export default useSetProperties;
